import React, { useEffect, useState } from 'react';
import {
    HashRouter as Router,
    Route,
    Switch,
    withRouter,
    Redirect,
} from 'react-router-dom';
import Homepage from './pages/homepage/Homepage';
import Center from './pages/center/Center';
import Autism from './pages/autism/Autism.component.jsx';
import Careers from './pages/careers/Careers';
import Blog from './pages/blog/Blog';
import Video from './components/reader/Video';
import Media from './pages/media-center/Media';
import ArticlesAndResearch from './pages/articlesAndResearch/ArticlesAndResearch';
import MediaCenterImages from './pages/mediaCenterImages/MediaCenterImages';
import Form from './pages/form/Form';
import { api_url, headers } from './common/config';
import './sass/main.scss';
import { useTranslation } from 'react-i18next';

function App() {
    const [emails, setEmails] = useState([]);
    const [files, setFiles] = useState([]);
    const [articles, setArticles] = useState([]);
    const [courses, setCourses] = useState([]);
    const [appState, setAppState] = useState({
        loading: false,
        response: null,
    });

    const { i18n } = useTranslation();
    useEffect(() => {
        setAppState({ loading: true });
        setDirection();
        // Collections
        fetch(`${api_url}/autism/collections`, {
            method: 'GET',
            // headers: headers,
        })
            .then((res) => res.json())
            .then((res) => {});

        // Articles
        fetch(
            `${api_url}/autism/items/articles_and_research?filter[status]=published`,
            {
                method: 'GET',
                // headers: headers,
            }
        )
            .then((res) => res.json())
            .then((res) => {
                setArticles(res.data);
            });

        // Courses
        fetch(`${api_url}/autism/items/courses?filter[status]=published`, {
            method: 'GET',
            // headers: headers,
        })
            .then((res) => res.json())
            .then((res) => {
                setCourses(res.data);
            });

        // Files
        fetch(`${api_url}/autism/files`, {
            method: 'GET',
            // headers: headers,
        })
            .then((res) => res.json())
            .then((res) => {
                setFiles(res.data);
            });

        // fetch(`${api_url}/autism/items/mailing_list`, {
        //     method: 'GET',
        //     headers: headers,
        // })
        //     .then((res) => res.json())
        //     .then((res) => {
        //         setEmails(res);
        //     });
    }, [setAppState]);

    const setDirection = () => {
        if (i18n.language === 'ar') {
            document.getElementsByTagName('html')[0].setAttribute('lang', 'ar');
            document.getElementsByTagName('html')[0].setAttribute('dir', 'rtl');
            document.getElementById('root').style.textAlign = 'right';
            document.getElementById('root').dir = 'rtl';
        } else if (i18n.language === 'en') {
            document.getElementsByTagName('html')[0].setAttribute('lang', 'en');
            document.getElementsByTagName('html')[0].setAttribute('dir', 'ltr');
            document.getElementById('root').style.textAlign = 'left';
            document.getElementById('root').dir = 'ltr';
        } else {
            console.log('Something went wrong');
        }
    };
    // Users
    return (
        <Router>
            <div>
                <Switch>
                    <Route
                        exact
                        path='/'
                        render={(props) => (
                            <Homepage
                                {...props}
                                emails={emails}
                                files={files}
                                articles={articles}
                                courses={courses}
                            />
                        )}
                    />
                    <Route exact path='/center' component={Center} />
                    <Route
                        exact
                        path='/autism'
                        render={(props) => (
                            <Autism {...props} articles={articles} />
                        )}
                    />
                    <Route exact path='/blog' component={Blog} />
                    <Route exact path='/media' component={Media} />
                    <Route path='/careers' component={Careers} />
                    <Route
                        exact
                        path='/media/image/:id'
                        component={MediaCenterImages}
                    />
                    <Route
                        exact
                        path='/:page/video/:id'
                        component={(props) => <Video {...props} />}
                    />
                    <Route
                        path='/blog/:type/:id'
                        component={(props) => (
                            <ArticlesAndResearch {...props} />
                        )}
                    />
                    <Route
                        exact
                        path='/register/child'
                        component={(props) => <Form {...props} child />}
                    />
                    <Route
                        exact
                        path='/register/job/:id'
                        component={(props) => <Form {...props} job />}
                    />

                    <Route render={() => <h1>404 page not found</h1>} />
                </Switch>
            </div>
        </Router>
    );
}

export default App;
